export default "__VITE_ASSET__2aJ1TsSH__"